import { createContext } from "react";
import { ConnectionStatus, RSocketState } from "../types";

// Default context state
const defaultState: RSocketState = {
    isConnected: false,
    status: ConnectionStatus.DISCONNECTED,
    lastError: null,
    messagesReceived: 0,
    connect: async () => {
        /* Default implementation */
        console.debug("socket connect");
        return Promise.resolve();
    },
    disconnect: () => {
        /* Default implementation */
        console.debug("socket disconnect");
        return undefined;
    },
    subscribeTopic: async () => {
        return Promise.resolve({
            isSubscribed: () => false,
            cancel: () => {
                /* Default implementation */
                console.debug("socket subscribeTopic cancel");
            },
        });
    },
    getCurrentSubscriptions: () => [],
};

export const RSocketContext = createContext<RSocketState>(defaultState);
